import { getNavigator } from "@faire/web--source/common/globals/getNavigator";
export var isChromeLighthouse = function() {
    var _getNavigator;
    return !!((_getNavigator = getNavigator()) === null || _getNavigator === void 0 ? void 0 : _getNavigator.userAgent.toLowerCase().includes("chrome-lighthouse"));
};
